import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function TransporteAnexo21Y22RMF2026SGM() {
  return <CategoryPage category="transporteAnexo21Y22Rmf2026SGM2026" pageTitle="Sistema de Gestión de Medición 2026" />;
}

export default TransporteAnexo21Y22RMF2026SGM;
